import PropTypes from 'prop-types';
import { Avatar, Card, CardContent, Stack, Typography } from '@mui/material';

export const OverviewTotalCustomers = (props: any) => {
  const { sx, value, title, icon, onClick } = props;

  return (
    <Card 
      sx={{
        ...sx,
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 0.2s ease-in-out',
        '&:hover': onClick ? {
          transform: 'translateY(-4px)',
          boxShadow: 4,
        } : {},
      }}
      onClick={onClick}
    >
      <CardContent
        sx={{ paddingTop: '16px', paddingBottom: '16px', paddingX: '20px' }}
      >
        <Stack
          alignItems='flex-start'
          direction='row'
          justifyContent='space-between'
          spacing={3}
        >
          <Stack spacing={1}>
            <Typography
              color='text.secondary'
              variant='overline'
              sx={{ fontSize: '1rem' }}
            >
              {title}
            </Typography>
            <Typography variant='h4'>{value}</Typography>
          </Stack>
          <Avatar
            sx={{
              backgroundColor: 'primary.main',
              height: 56,
              width: 56,
            }}
          >
            {icon}
          </Avatar>
        </Stack>
      </CardContent>
    </Card>
  );
};

OverviewTotalCustomers.propTypes = {
  difference: PropTypes.number,
  positive: PropTypes.bool,
  value: PropTypes.number,
  sx: PropTypes.object,
  title: PropTypes.string,
  icon: PropTypes.any,
  onClick: PropTypes.func,
};
